import { useState, useEffect } from 'react'
import { api } from '../../services/api'
import './AdminDashboard.css'
import { MainLayout } from '../../Layout/MainLayout'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'

export function AdminDashboard() {
    const navigate = useNavigate()
    const [tab, setTab] = useState('dashboard')
    const { user } = useAuth()
    const isGerenteLoja = user?.position === 'gerente_loja'
    const navItems = [
        { key: 'dashboard', label: 'Dashboard' },
        { key: 'courses', label: 'Cursos' },
        { key: 'users', label: 'Usuários' },
        { key: 'responsibleArea', label: 'Área do Curso', hidden: isGerenteLoja },
        { key: 'branches', label: 'Filiais', hidden: isGerenteLoja },
    ]
    return (
        <MainLayout>
            <div className="container fade-in">
                <div className="admin-page">
                    <aside className="admin-side">
                        <div className="admin-side-label">Painel</div>
                        <nav className="admin-nav">
                            {navItems.filter(item => !item.hidden).map(item => (
                                <button
                                    key={item.key}
                                    className={tab === item.key ? 'on' : ''}
                                    onClick={() => setTab(item.key)}
                                >
                                    <span className="dot" />
                                    {item.label}
                                </button>
                            ))}
                        </nav>
                    </aside>

                    <div className="admin-content">
                        {tab === 'dashboard' && <DashboardTab />}
                        {tab === 'courses' && <CoursesTab />}
                        {tab === 'responsibleArea' && <ResponsibleAreaTab />}
                        {tab === 'users' && <UsersTab />}
                        {tab === 'branches' && <BranchesTab />}
                        {/* {tab === 'reports' && <ReportsTab />} */}
                    </div>
                </div>
            </div>
        </MainLayout>
    )
}

function DashboardTab() {
    interface RecentActivity {
        attemptId: string
        completedIn: string
        note: number
        approved: boolean
        timeSpentSeg: number
        user: {
            id: string
            name: string
            position: string
        }
        branch: {
            id: string
            name: string
            code: string
        }
        quiz: {
            id: string
            title: string
        }
        course: {
            id: string
            title: string
        }
    }

    const [recentActivities, setRecentActivities] = useState<RecentActivity[]>([])
    const [activeUsers, setActiveUsers] = useState()
    const [createdThisMonth, setCreatedThisMonth] = useState()
    const [percentCompleted, setPercentCompleted] = useState()
    const [usersCompletedQuiz, setUsersCompletedQuiz] = useState()
    const [totalQuizzesThisMonth, setTotalQuizzesThisMonth] = useState()
    const [avgNoteThisMonth, setAvgNoteThisMonth] = useState()
    useEffect(() => {
        api.get('/dash-data')
            .then(r => {
                setActiveUsers(r.data?.activeUsers)
                setCreatedThisMonth(r.data?.createdThisMonth)
                setPercentCompleted(r.data.quizStats.percentCompleted)
                setUsersCompletedQuiz(r.data.quizStats.usersCompletedQuiz)
                setTotalQuizzesThisMonth(r.data.quizStats.totalQuizzesThisMonth)
                setAvgNoteThisMonth(r.data.quizStats.avgNote)
            })
            .catch(() => {
                console.error('Erro ao Buscar Dados')
            })
        api.get('/dash-activities')
            .then(r => {
                setRecentActivities(r.data.data)
            })
            .catch(() => {
                console.error('Erro ao Buscar Dados')
            })
    }, [])
    return (
        <>
            <div className="stat-row">
                {[
                    { label: 'Colaboradores ativos', value: activeUsers, unit: '', trend: `↑ ${createdThisMonth} este mês`, up: true },
                    { label: 'Em dia com treinamentos', value: percentCompleted, unit: '%', trend: `${usersCompletedQuiz} usuários completaram quiz`, up: true },
                    { label: 'Quizzes realizados Mês', value: totalQuizzesThisMonth, unit: '', trend: '', up: true },
                    { label: 'Nota média geral', value: avgNoteThisMonth, unit: '', trend: '', up: true },
                ].map((s, i) => (
                    <div key={i} className="stat">
                        <div className="stat-label">{s.label}</div>
                        <div className="stat-value">{s.value}<span className="unit">{s.unit}</span></div>
                        <div className={`stat-trend ${s.up ? '' : 'down'}`}>{s.trend}</div>
                    </div>
                ))}
            </div>

            <div className="table-card">
                <div className="table-card-head">
                    <h4 className="serif">Atividade recente</h4>
                </div>
                <table className="data">
                    <thead>
                        <tr><th>Aluno</th><th>Filial</th><th>Curso</th><th>Nota</th><th>Quando</th></tr>
                    </thead>
                    <tbody>
                        {recentActivities.map((ra, i) => (
                            <tr key={i}>
                                <td><strong style={{ color: 'var(--text)', fontWeight: 500 }}>{ra.user.name}</strong></td>
                                <td style={{ color: 'var(--text-2)' }}>{ra.branch.name}</td>
                                <td style={{ color: 'var(--text-2)' }}>{ra.course.title}</td>
                                <td style={{ fontFamily: 'var(--font-display)', fontSize: 18, color: (ra.note as number) >= 7 ? 'var(--teal)' : 'var(--red)' }}>{Number(ra.note).toFixed(1)}</td>
                                <td style={{ color: 'var(--text-3)' }}>{new Date(ra.completedIn).toLocaleDateString('pt-BR', {
                                    day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit'
                                })}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    )
}

function CoursesTab() {
    const navigate = useNavigate()
    const [courses, setCourses] = useState<any[]>([])
    const { user } = useAuth()
    useEffect(() => {
        async function loadData() {
            try {
                const { data } = await api.get('/course')

                const coursesWithRegistered = await Promise.all(
                    data.data.map(async (course: any) => {
                        const progress = await api.get(
                            `/progress/course/${course.id}`
                        )
                        const heaveVideo = await api.get(
                            `/video/${course.id}`
                        )
                        console.log('video', heaveVideo)
                        const heaveQuiz = await api.get(
                            `/course/${course.id}/quizzes`
                        )

                        return {
                            ...course,
                            userRegistered: progress.data.userRegistered,
                            hasVideo: heaveVideo.data?.length > 0 || heaveVideo.data?.data?.length > 0,
                            hasQuiz: heaveQuiz.data?.length > 0 || heaveQuiz.data?.data?.length > 0,
                        }
                    })
                )
                setCourses(coursesWithRegistered)
            } catch (err) { }
        }
        loadData()
    }, [])

    return (
        <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 22 }}>
                <div style={{ fontSize: 13, color: 'var(--text-2)' }}>{courses.length} cursos cadastrados</div>
                {user?.position === 'admin' && (
                    <button className="btn btn-primary" onClick={() => navigate('/admin/create-course')}>
                        + Novo curso
                    </button>
                )}
            </div>
            <div className="courses-list">
                <div className="courses-list-row head">
                    <div>Curso</div><div>Inscritos</div><div>Status</div><div>Video</div><div>Quiz</div>
                </div>
                {courses.map(c => (
                    <div key={c.id} className="courses-list-row">
                        <div>
                            <div className="clrow-title serif"><button onClick={() => navigate(`/admin/course-details/${c.id}`)} style={{fontSize:'20px'}}>{c.title}</button></div>
                            <div className="clrow-sub">{c.area?.name} · {c.estimatedDurationMin} min</div>
                        </div>
                        <div style={{ color: 'var(--text)' }}>{c.userRegistered ?? 0}</div>
                        <div>
                            {c.status === 'publicado' ? (
                                <span className="status-chip ok">Publicado</span>
                            ) : (
                                <span
                                    className="status-chip warn"
                                    style={{ cursor: 'pointer' }}
                                    title="Clique para publicar"
                                    onClick={async () => {
                                        try {
                                            await api.put(`/course-publish/${c.id}`)
                                            setCourses(prev => prev.map(course =>
                                                course.id === c.id ? { ...course, status: 'publicado' } : course
                                            ))
                                        } catch {
                                            alert('Erro ao publicar curso')
                                        }
                                    }}
                                >
                                    Publicar
                                </span>
                            )}
                        </div>
                        <div>
                            {c.hasVideo
                                ? <button className="btn btn-ghost" style={{ fontSize: 12, padding: '5px 12px' }} onClick={() => navigate('/admin/create-video', { state: { courseId: c.id } })}>Módulos</button>
                                : (
                                    <button
                                        className="btn btn-ghost"
                                        style={{ fontSize: 12, padding: '5px 12px' }}
                                        onClick={() => navigate('/admin/create-video', { state: { courseId: c.id } })}
                                    >
                                        Adicionar Vídeo
                                    </button>
                                )
                            }
                        </div>
                        <div style={{}}>
                            {c.hasQuiz
                                ? <span className="status-chip ok">Sim</span>
                                : (
                                    <button
                                        className="btn btn-ghost"
                                        style={{ fontSize: 12, padding: '5px 12px' }}
                                        onClick={() => navigate('/admin/create-quiz', { state: { courseId: c.id } })}
                                    >
                                        Adicionar Quiz
                                    </button>
                                )}
                        </div>
                    </div>
                ))}
            </div>
        </>
    )
}

function BranchesTab() {
    const [branches, setBranches] = useState<any[]>([])
    const navigate = useNavigate()
    const { user } = useAuth()
    useEffect(() => {
        api.get('/branch').then(r => setBranches(r.data.data)).catch(() => { })
    }, [])

    return (
        <div className="table-card">
            <div className="table-card-head">
                <h4 className="serif">Filiais</h4>
                {user?.position === 'admin' && (
                    <button className="btn btn-primary" onClick={() => navigate(`/admin/create-branch`)}>+ Nova Filial</button>
                )}
            </div>
            <table className="data">
                <thead>
                    <tr><th>Código</th><th>Cidade</th><th>Estado</th><th>Regional</th></tr>
                </thead>
                <tbody>
                    {branches.map(b => (
                        <tr key={b.id}>
                            <td style={{ color: 'var(--text)', fontWeight: 500 }}>{b.name}</td>
                            <td style={{ color: 'var(--text-2)', fontFamily: 'var(--font-mono)', fontSize: 12 }}>{b.city}</td>
                            <td style={{ color: 'var(--text-2)' }}>{b.state}</td>
                            <td style={{ color: 'var(--text-2)' }}>{b.regional.code}-{b.regional.name || '—'}</td>


                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

function UsersTab() {
    const [users, setUsers] = useState<any[]>([])
    const navigate = useNavigate()
    const { user } = useAuth()
    useEffect(() => {
        api.get('/user').then(r => setUsers(r.data.data)).catch(() => { })
    }, [])

    return (
        <div className="table-card">
            <div className="table-card-head">
                <h4 className="serif">Usuários</h4>
                {user?.position === 'admin' && (
                    <button className="btn btn-primary" onClick={() => navigate(`/admin/create-user`)}>+ Novo usuário</button>
                )}
            </div>
            <table className="data">
                <thead>
                    <tr><th>Nome</th><th>CPF</th><th>Cargo</th><th>Filial</th><th>Ultimo Acesso</th><th>Status</th></tr>
                </thead>
                <tbody>
                    {users.map(u => (
                        <tr key={u.id}>
                            <td style={{ color: 'var(--text)', fontWeight: 500 }}>{u.name}</td>
                            <td style={{ color: 'var(--text-2)', fontFamily: 'var(--font-mono)', fontSize: 12 }}>{u.cpf}</td>
                            <td style={{ color: 'var(--text-2)' }}>{u.position}</td>
                            <td style={{ color: 'var(--text-2)' }}>{u.branch || '—'}</td>
                            <td style={{ color: 'var(--text-2)' }}>
                                {u.lastAccess
                                    ? new Date(u.lastAccess).toLocaleString('pt-BR', {
                                        timeZone: 'America/Sao_Paulo'
                                    })
                                    : '—'}
                            </td>
                            <td>
                                <span className={`status-chip ${u.active ? 'ok' : 'bad'}`}>
                                    {u.active ? 'Ativo' : 'Inativo'}
                                </span>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

function ResponsibleAreaTab() {
    const [responsibleArea, setResponsibleArea] = useState<any[]>([])
    const navigate = useNavigate()
    const {user} = useAuth()
    useEffect(() => {
        api.get('/responsible-area').then(r => setResponsibleArea(r.data?.data ?? r.data)).catch(() => { console.error('erro ao buscar dados') })
    }, [])

    return (
        <div className="table-card">
            <div className="table-card-head">
                <h4 className="serif">Área do Curso</h4>
                {user?.position === 'admin' && (
                    <button className="btn btn-primary" onClick={() => navigate(`/admin/create-responsilbe-area`)}>+ Nova Área</button>
                )}
                
            </div>
            <table className="data">
                <thead>
                    <tr><th>Nome</th><th>Status</th></tr>
                </thead>
                <tbody>
                    {responsibleArea.map(u => (
                        <tr key={u.id}>
                            <td style={{ color: 'var(--text)', fontWeight: 500 }}>{u.name}</td>
                            <td>
                                <span className={`status-chip ${u.active ? 'ok' : 'bad'}`}>
                                    {u.active ? 'Ativo' : 'Inativo'}
                                </span>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

function ReportsTab() {
    return (
        <>
            <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 22 }}>
                {['Últimos 30 dias', 'Este trimestre', 'Ano'].map((p, i) => (
                    <span key={p} className={`pill ${i === 0 ? 'on' : ''}`}>{p}</span>
                ))}
                <span style={{ flex: 1 }} />
                <button className="btn btn-ghost">↓ Exportar Excel</button>
            </div>
            <div className="stat-row" style={{ gridTemplateColumns: 'repeat(3, 1fr)' }}>
                {[
                    { label: 'E-mails disparados', value: '8.4', unit: 'k', trend: 'Notas pós-quiz pro gestor' },
                    { label: 'Taxa de aprovação', value: '84', unit: '%', trend: '↑ 3 pp vs. trimestre' },
                    { label: 'Tempo médio / curso', value: '14', unit: 'min', trend: 'Em linha com a meta' },
                ].map((s, i) => (
                    <div key={i} className="stat">
                        <div className="stat-label">{s.label}</div>
                        <div className="stat-value">{s.value}<span className="unit">{s.unit}</span></div>
                        <div className="stat-trend">{s.trend}</div>
                    </div>
                ))}
            </div>
        </>
    )
}